import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 volumes', '5 bonuses', '240 pages', 'Grade R–9'];
const reassurances = ['Instant download', 'Printable PDFs', '7-day satisfaction guarantee'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15ckj6u4yuabf">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jc3hkv7z67aj" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1eds6yi9uvsr9">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1wp9l4zy29i">
          Your PE year can be <em className="text-red-700" data-id="element-118" data-mp="1o4n44hon4crh">ready today.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="222uta3ffq9s3">
          Instead of searching for activities, drawing every diagram yourself and spending your evenings planning, you have an organised PE system for the whole year. More time for what really matters:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s5qopxrp58uq">
          Your learners. Your teaching. Your life outside school.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="122liy4gxsn37">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="163p2b0y71196">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b3jquxuhxer2">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1ftqeaud9ut7q">One-off payment – no subscription.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1kt3aw6ty3eni">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1kstgm71valc0" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1pt8xv9p9scz9">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="1tukrrrf6fkd9">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3qtvz0hy81cic" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}